module.exports = __webpack_public_path__ + "img/GAME_NIGHTSKY.cd595eff.png";